import { SignUp } from "@clerk/clerk-react";
import { Link } from "react-router-dom";
import { RoutePath } from "@/routePaths";
import { AuthHeroSection } from "@/components/auth/AuthHeroSection";
import { KiwiPatternBackground } from "@/components/auth/KiwiPatternBackground";

export function SignUpPage() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-background overflow-hidden">
      <KiwiPatternBackground />

      <div className="relative z-10 w-full max-w-md px-6">
        <AuthHeroSection />

        <SignUp routing="hash" signInUrl={RoutePath.SignIn} />

        <p className="mt-6 text-center text-sm text-muted-foreground">
          Already have an account?{" "}
          <Link
            to={RoutePath.SignIn}
            className="text-primary font-medium hover:underline"
          >
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
